import React from 'react';
import './VideoLoader.css';

const VideoLoader = () => {
    return (
        <div className="video-loader-container">
            <video 
                autoPlay 
                muted 
                playsInline 
                className="loader-video"
            >
                <source src="https://caninecrown.ascentbw.com/Image/Loader.webm" type="video/webm" />
                <source src="https://caninecrown.ascentbw.com/Image/Loader.mp4" type="video/mp4" />
                <track kind="captions" />
                Your browser does not support the video tag.
            </video>
        </div>
    );
};

export default VideoLoader;
